/*=========================================================================================
  File Name: store.js
  Description: Vuex store
==========================================================================================*/

import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'

window.moment = moment

import conference from "./modules/conference";
import subject from "./modules/subject";
import question from "./modules/question";
import exercise from "./modules/exercise";
import course from "./modules/course";
import lesson from "./modules/lesson";
import account from "./modules/account";
import quiz from "./modules/quiz";
import video from "./modules/video";
import chat from "@/store/modules/chat";
import dashboard from "@/store/modules/dashboard";

Vue.use(Vuex)

function getSize(size) {
  if (size < 479) return 'xs'
  else if (size < 749) return 'md'
  return 'lg'
}

window.addEventListener('resize', function () {
  store.commit('set_mobile', window.innerWidth <= 768)
})

const store = new Vuex.Store({
  getters: {
    home_url: state => state.home_url,
    user: state => state.user,
    classroom: state => state.classroom,
    now: state => state.now,
    mobile: state => state.mobile,
    logo: (state) => {
      return process.env.VUE_APP_PROXY + '/images/logo.jpg'
    },
    logo_mini: (state) => {
      return process.env.VUE_APP_PROXY + '/images/logo_mini.jpg'
    },
  },
  mutations: {
    set_mobile(state, value) {
      state.mobile = value
    },
    set_user: (state, payload) => {
      state.user = payload
    },
    set_data: (state, payload) => {
      state.home_url = payload.home_url
      state.user = payload.user
      state.classroom = payload.classroom
    },
    update_now: (state) => {
      state.now = moment()
    }
  },
  state: {
    home_url: null,
    user: null,
    classroom: null,
    now: moment(),
    mobile: window.innerWidth <= 768
  },
  actions: {},
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    dashboard,
    conference,
    subject,
    question,
    exercise,
    course,
    lesson,
    account,
    video,
    quiz,
    chat
  }
})

const interval = setInterval(() => store.commit('update_now'), 1000)

export default store
